import { Stack, Typography } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Affiliate.HunterAffiliate;

export const HunterAffiliateDescription = () => {
  const { t } = useResource();
  const apiUrl = getApiUrl();

  return (
    <Stack gap={4}>
      <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
      <Typography>{t(RESOURCES.Description)}</Typography>
      <Typography>
        {t(RESOURCES.TermsLinkPretext)}{" "}
        <UnstyledLink
          to={t(
            Resources.Pages.Content.LegalDocuments.Documents.Hunter
              .affiliateTerms.url,
            { apiUrl },
          )}
          target="_blank"
          rel="noreferrer"
        >
          {t(RESOURCES.TermsLink)}
        </UnstyledLink>
        .
      </Typography>
      <Typography>{t(RESOURCES.InviteNow)}</Typography>
    </Stack>
  );
};
